import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0A303C',
        lunargreen: '#365136',
        mediumcarmine: '#AB3B46',
      }
    }
  }
});
